var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-aside',{staticClass:"layout-aside select-none",class:{ 'is-collapse': _vm.isCollapse }},[_c('Menu',{attrs:{"data":_vm.routes},on:{"feedback":function($event){return _vm.$emit('feedback')},"operationManual":function($event){return _vm.$emit('operationManual')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }